import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { filter, firstValueFrom, take } from 'rxjs';

import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';
import { SystemService } from '@shared/service/system/system.service';

@Injectable({ providedIn: 'root' })
export class DashboardViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);
  private systemService = inject(SystemService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    // Wait for system initialization
    await firstValueFrom(
      this.systemService.isInitialized$.pipe(
        filter((val) => val),
        take(1),
      ),
    );

    // Allow access - component will show appropriate view based on permissions
    // The component handles permission-based UI (showBasicDashboard vs custom dashboards)
    // No need to redirect here as that causes infinite loop with root → dashboard redirect
    await this.routeGuardService.handleRoute(this.getView(), route);
    return true;
  }

  getView(): View {
    return {
      route: 'dashboard',
      iframeUrl: 'dashboard/',
    };
  }
}
